import { ReportAvailability } from 'model/ReportAvailability';
import { Pagination as PaginationModel } from 'model/Pagination';
import { QuestionsStats as QuestionStatsType } from 'model/Question';
import { SentimentState } from 'model/Sentiment';
import { ProjectModel } from 'model/Project.model';
import { ProjectListItemModel } from 'model/ProjectListItem.model';
import { Resource } from 'model/Resource';
import { ProjectLiveSettingsModel } from 'api/dto/ProjectLiveSettingsDto';
import { ProjectKind } from 'model/ProjectKind';
import { FocusAreasModel } from 'api/dto/new/FocusArea.dto';

export const STORE_NAME = 'project';

export namespace ProjectState {
  export type Domain = {
    current: Resource<ProjectModel>;
    list: Resource<ProjectListItemModel[]>;
    pagination: PaginationModel | null;
    questionsStats: Resource<QuestionStatsType | null>;
    reportAvailabilities: Resource<ReportAvailability[]>;
    sentiment: Resource<SentimentState>;
    liveSettings: Resource<ProjectLiveSettingsModel | null>;
    kind: Resource<ProjectKind | null>;
    focusAreas: Resource<FocusAreasModel | null>;
  };

  export const INITIAL_DOMAIN: ProjectState.Domain = {
    current: Resource.createPendingResource({} as ProjectModel),
    list: Resource.createPendingResource([]),
    pagination: null,
    questionsStats: Resource.createPendingResource(null),
    reportAvailabilities: Resource.createPendingResource([]),
    sentiment: Resource.createPendingResource(SentimentState.Off),
    liveSettings: Resource.createPendingResource(null),
    kind: Resource.createPendingResource(null),
    focusAreas: Resource.createPendingResource(null),
  };

  export const DEFAULT_AGGREGATION_MONTHS = 12;
}

export type ProjectState = {
  project: ProjectState.Domain;
};
